import { render, staticRenderFns } from "./items-type-part.vue?vue&type=template&id=7b39dcc2&scoped=true&"
import script from "./items-type-part.vue?vue&type=script&lang=js&"
export * from "./items-type-part.vue?vue&type=script&lang=js&"
import style0 from "./items-type-part.vue?vue&type=style&index=0&id=7b39dcc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b39dcc2",
  null
  
)

export default component.exports